enum PrescriptionPrintType {
    Regular = 0,
    Thermal = 1,
    Mexico = 2
}

export { PrescriptionPrintType };
